<p-scrollPanel [style]="{width: '100%', height: '60vh'}">
  <form #f="ngForm" (ngSubmit)="onSubmit()">
    <div class="container-fluid">
      <div class="login-spiner" *ngIf="show_spin" aria-hidden="true">
        <div class="nb-spinner" role="status">
          <span class="sr-only">...</span>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div role="alert" class="alert alert-info">
            <i aria-hidden="true" class="fas fa-1-5x fa-info-circle m-r-xs"></i>
            Introduzca las credenciales de acceso a los servicios de firma
          </div>
        </div>
        <div *ngIf="errorMsg" class="col-12">
          <div role="alert" class="alert alert-danger">
            <i class="fa fa-exclamation-triangle  m-r-xs" aria-hidden="true"></i>
            {{ errorMsg }}
          </div>
        </div>
        <div class="col-12" *ngIf="!config?.userHidden">
          <formElement [model]="data" [fieldConfig]="getUsernameFieldConfig()"></formElement>
        </div>
        <div class="col-12">
          <formElement [model]="data" [fieldConfig]="getPassWordFieldConfig()"></formElement>
        </div>
      </div>
      <div class="row m-b-md justify-content-center">
        <button tabindex="3" type="submit" class="btn btn-primary block m-b btn-lg"
          [disabled]="!this.data.password || !this.data.user">
          {{ 'General.accept' | translate }}
        </button>
      </div>
    </div>
  </form>
</p-scrollPanel>